import { FC } from "react";
import { Description as DialogDescription, Title as DialogTitle } from "@radix-ui/react-dialog";
import { AiOutlineClose } from "react-icons/ai";
import { Button } from "components/common/buttons/Button";
import { ModalTitleIcon } from "../ModalTitleIcon/ModalTitleIcon";
import { cn } from "utils/cn";
import type { PanelHeaderProps } from "./PanelHeader.types";

export const PANEL_SUBTITLE_CLASS = "text-xs leading-snug text-muted-foreground";

export const PanelHeader: FC<PanelHeaderProps> = ({
  title,
  icon,
  subtitle,
  onClose,
  closeDisabled = false,
  children,
  className,
  useDialogTitle = false,
}) => (
  <div className={cn("border-b border-border bg-background p-4", className)}>
    <div className="flex items-start justify-between gap-2">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {icon ? <ModalTitleIcon>{icon}</ModalTitleIcon> : null}
        <div className="flex min-w-0 flex-col gap-0.5">
          {useDialogTitle ? (
            <DialogTitle asChild>
              <h3 className="m-0 text-base font-semibold leading-tight text-foreground">{title}</h3>
            </DialogTitle>
          ) : (
            <h3 className="m-0 text-base font-semibold leading-tight text-foreground">{title}</h3>
          )}
          {subtitle ? (
            useDialogTitle ? (
              <DialogDescription asChild>
                <p className={PANEL_SUBTITLE_CLASS}>{subtitle}</p>
              </DialogDescription>
            ) : (
              <p className={PANEL_SUBTITLE_CLASS}>{subtitle}</p>
            )
          ) : null}
        </div>
      </div>
      {onClose ? (
        <Button
          name="close"
          color="gray"
          size="icon"
          className="h-7 w-7 shrink-0"
          type="button"
          onClick={onClose}
          disabled={closeDisabled}
          aria-label="Close modal"
        >
          <AiOutlineClose />
        </Button>
      ) : null}
    </div>
    {children}
  </div>
);
